import type { DataDimensionProps } from "../components/dimensions/DataDimension";
import type { DateDimensionProps } from "../components/dimensions/DateDimension";
import type { DropdownDimensionProps } from "../components/dimensions/DropdownDimension";
import type { InputDimensionProps } from "../components/dimensions/InputDimension";
import type { ListBuilderDimensionProps } from "../components/dimensions/ListBuilderDimension/ListBuilder.dimension";
import type { MultiSelectDimensionProps } from "../components/dimensions/MultiSelectDimension";
import type { MultiSelectStaticDimensionProps } from "../components/dimensions/MultiSelectStaticDimension";
import type { OpportunityDropdownDimensionProps } from "../components/dimensions/OpportunityDropdownDimension";
import type { StaticDropdownDimensionProps } from "../components/dimensions/StaticDropdownDimension";
import type { TargetSegmentPickerDimensionProps } from "../components/dimensions/vitest/TargetSegmentPickerDimension";

export enum DimensionTypes {
    INPUT = "input",
    DROPDOWN = "dropdown",
    OPPORTUNITY_DROPDOWN = "opportunity_dropdown",
    STATIC_DROPDOWN = "static_dropdown",
    DATE = "date",
    MARKDOWN = "markdown",
    DATA = "data",
    MULTISELECT = "multiselect",
    MULTI_SELECT_STATIC = "multi_select_static",
    TARGET_SEGMENT_PICKER = "target_segment_picker",
    LIST_BUILDER = "list_builder",
}

export interface DimensionConfiguration {
    label: string;
    tooltip?: string;
    isAdvertiserScoped?: boolean;
}

export type Dimension = string;

export type DimensionTemplates =
    | InputDimensionProps
    | DropdownDimensionProps
    | StaticDropdownDimensionProps
    | DateDimensionProps
    | OpportunityDropdownDimensionProps
    | DataDimensionProps
    | MultiSelectDimensionProps
    | MultiSelectStaticDimensionProps
    | TargetSegmentPickerDimensionProps
    | ListBuilderDimensionProps;

export interface RequestParameterMapper {
    value: string;
}

export interface DimensionTemplate {
    id: Dimension;
    type: DimensionTypes;
    configuration: DimensionConfiguration;
    dependencies: Dimension[];
    optional?: boolean;
    requestParameterMap?: Record<string, string>;
    dimensionMetadata?: DimensionMetadata;
    debug?: boolean;
}

export interface DimensionMetadata {
    domainIdentifier: string;
}

export const DimensionInitIgnore = [DimensionTypes.MARKDOWN];
